import React from 'react';

import useLoader, { getTexture } from '@/game/useLoader';

type Anchor = number | { x: number; y: number } | [number, number];

function toAnchor(anchor: Anchor): number | { x: number; y: number } {
  if (Array.isArray(anchor)) {
    return { x: anchor[0], y: anchor[1] };
  }
  return anchor;
}

export type Props = {
  anchor: Anchor;
  position: 'top' | 'bottom' | 'left' | 'right';
  width: number;
  height: number;
  x?: number;
  y?: number;
};

const BorderLine = ({
  anchor,
  position,
  width,
  height,
  x = 0,
  y = 0,
}: Props) => {
  const { loaded } = useLoader();

  if (!loaded) return null;

  const texture = getTexture(`plank-${position}`);

  return (
    <pixiContainer>
      <pixiTilingSprite
        anchor={toAnchor(anchor)}
        texture={texture}
        width={width}
        height={height}
        x={x}
        y={y}
      />
    </pixiContainer>
  );
};

export default BorderLine;
